export default "/images/frontPageBackgroundImage2.jpg?c666cd96a922268866810e1ce6100c54";